import React, { useState } from "react"
import VSensor from "react-visibility-sensor"

const createPayloadHash = (payload, moduleName) => {
  return btoa(encodeURIComponent(JSON.stringify(payload))) + moduleName
}

const ga4StoredHashes = []
const VisibilitySensorGA4 = ({ moduleName, className, children, product }) => {
  const [active, setActive] = useState(false)
  const moduleViewItemList = [
    "CategoriesProductListV3VideoManualModule",
    "CategoriesProductListV2ManualModule",
  ]
  const onChange = isVisible => {
    if (!active) {
      setActive(isVisible)
    }
    if (isVisible && moduleViewItemList.includes(moduleName)) {
      let tracking = {
        ecommerce: {
          im_collection_name:
            product?.field_value?.list_box_v2_cta?.field_value?.tracking_ga4
              ?.product?.im_collection_name,
          im_type:
            product?.field_value?.list_box_v2_cta?.field_value?.tracking_ga4
              ?.product?.im_type,
          im_module_name: moduleName,
          items:
            product?.field_value?.list_box_v2_cta?.field_value?.tracking_ga4
              ?.items,
        },
      }
      if (tracking.ecommerce.items && tracking.ecommerce.items[0]) {
        tracking.ecommerce.items[0].index = parseInt(children.key) + 1
        tracking.ecommerce.items[0].item_list_id = moduleName
        tracking.ecommerce.items[0].item_list_name =
          product?.field_value?.list_box_v2_title?.field_value
      }
      const hash = createPayloadHash(tracking, moduleName)
      if (!ga4StoredHashes.includes(hash)) {
        ga4StoredHashes.push(hash)
        window.snakeAnalytics = window.snakeAnalytics || []
        window.snakeAnalytics.push(["event", "view_item_list", tracking])
      }
    }

    if (isVisible && moduleName === "FiguresGridAutomaticModule") {
      let tracking = {
        ecommerce: {
          im_collection_name:
            product?.field_value?.tracking_ga4?.product?.im_collection_name,
          im_type: product?.field_value?.tracking_ga4?.product?.im_type,
          im_module_name: moduleName,
          items: product?.field_value?.tracking_ga4?.items || [],
        },
      }

      if (tracking.ecommerce.items && tracking.ecommerce.items[0]) {
        tracking.ecommerce.items[0].index = parseInt(children.key) + 1
        tracking.ecommerce.items[0].item_list_id = moduleName
        tracking.ecommerce.items[0].item_list_name =
          product?.field_value?.figure_title?.field_value
      }

      const hashCardBackIssues = createPayloadHash(tracking, moduleName)

      if (!ga4StoredHashes.includes(hashCardBackIssues)) {
        ga4StoredHashes.push(hashCardBackIssues)
        window.snakeAnalytics = window.snakeAnalytics || []
        window.snakeAnalytics.push(["event", "view_item_list", tracking])
      }
    }
  }

  return (
    <VSensor moduleName={moduleName} partialVisibility onChange={onChange}>
      <div className={`visibilitySensorGA4 ${className}`}>{children}</div>
    </VSensor>
  )
}

export default VisibilitySensorGA4
